<script>
export default {
    data() {
        return {};
    },

    props: {
        src: {
            type: String,
            default: "",
        },
        href: {
            type: String,
            default: "",
        },
    },

    computed: {},

    watch: {},

    methods: {},

    components: {},

    created() {},
    mounted() {},
};
</script>

<style></style>

<template>
    <a
        v-if="href.length"
        :href="href"
        class="image lazy-background-image"
        v-lazy:background-image="src"
        :key="src"
    >
        <slot />
    </a>
    <div
        v-else
        class="image lazy-background-image"
        v-lazy:background-image="src"
        :key="src"
    >
        <slot />
    </div>
</template>
